<template lang="pug" src="./payouts.pug"> </template>
<style lang="scss" src="./payouts.scss" scoped> </style>

<script>

import { mapState, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import validate from '@/mixins/validate'
import scroll from '@/utils/scroll'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        payoutDialog: false,
        withdraw: null,
        selectAll: false,
        filters: {
            fromDate: null,
            toDate: null,
            status: null,
            query: null
        },
        sorting: {},
        newComment: null
    }),
    validations: {
        withdraw: {
            decimal: function(val) {
                return Number(val) == val && val > 0
            },
            availablePrice: function(val) {
                return val <= this.user.balance / 100
            },
            multipleOf: function(val) {
                return val % 100 === 0
            }
        }
    },
    computed: {
        ...mapGetters(['type', 'user', 'permissions']),
        ...mapState({
            payouts: (state) => state.payout.payouts,
            isTableLoad: (state) => state.payout.isLoaded,
            pagination: (state) => state.payout.pagination,
            appliedFilters: (state) => state.payout.filters
        }),
        statuses: function() {
            return ['new', 'processing', 'cancelled', 'success'].map(it => ({
                text: this.$vuetify.t(`$vuetify.pages.Payouts.statuses.${it}`),
                value: it
            }))
        },
        headers() {
            return [
                { text: '№', sortable: false, show: ['leader', 'business'], number: true },
                { text: 'accountId', value: '"accountId"', show: ['admin'] },
                { text: 'type', value: '"account"."type"', show: ['admin'] },
                { text: 'email', value: '"account"."email"', show: ['admin'] },
                { text: 'firstName', value: '"account"."firstName"', show: ['admin'] },
                { text: 'lastName', value: '"account"."lastName"', show: ['admin'] },
                { text: 'phoneNumber', value: '"account"."phoneNumber"', show: ['admin'] },
                { text: 'sum', value: 'sum' },
                { text: 'balance', value: 'balance' },
                { text: 'status', value: 'status' },
                { text: 'cardNumber', value: '"cardNumber"' },
                { text: 'comment', value: '"comment"', sortable: false, show: ['admin'] },
                { text: 'updatedAt', value: '"updatedAt"' },
                { text: 'createdAt', value: '"createdAt"' },
                { text: '', sortable: false, show: ['admin'], number: true }
            ]
                .filter(it => it.show ? this.isShow(it.show) : true)
                .map(it => Object.assign(it, {
                    text: it.number ? it.text : this.$vuetify.lang.t(`$vuetify.pages.Payouts.table.${it.text}`)
                }))
        },
        disabledPayout() {
            return !this.user || !this.user.processedAfterRestrictions
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getPayoutsByPage()
            },
            deep: true
        }
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters)
        this.getPayoutsByPage(this.pagination.page)
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('payout/SET_PAGINATION', { page: 1, length: null })
        next()
    },
    methods: {
        reset() {
            this.filters = Object.assign({}, {
                status: null,
                fromDate: null,
                toDate: null,
                query: null
            })
            this.$store.commit('payout/RESET_PAYOUTS')
            this.getPayoutsByPage()
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getPayoutsByPage(page, true)
            }
        },
        getPayoutsByPage(page = 1, isScrollEnable = false, excel = false) {
            this.$store.dispatch('payout/getPayouts', {
                page,
                excel,
                column: this.sorting.sortBy,
                direction: this.sorting.descending ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(_ => {
                if (isScrollEnable) {
                    scroll(this.$refs.table)
                }
            })
        },
        submit() {
            this.$store.commit('payout/SET_FILTERS', Object.assign({}, this.filters))
            this.getPayoutsByPage()
        },
        isShow(types) {
            return types.includes(this.type)
        },
        changeFromDate(date) {
            this.filters.fromDate = date
        },
        changeToDate(date) {
            this.filters.toDate = date
        },
        changeStatus(status, id) {
            this.$store.dispatch('payout/changeStatus', { id, status })
        },
        saveComment(comment, id) {
            this.$store.dispatch('payout/comment', { id, comment: this.newComment })
                .then(status => {
                    if (status !== 204) return

                    const index = this.payouts.findIndex(it => it.id === id)
                    if (index !== -1) {
                        this.$set(this.payouts[index], 'comment', this.newComment)
                    }

                    this.newComment = null
                })
        },
        async payout() {
            await this.$store.dispatch('payout/payout', { sum: this.withdraw * 100 })
            this.withdraw = null
            this.selectAll = false
            this.$v.$reset()
            this.reset()
        },
        onChange() {
            const balance = this.user.balance / 100
            this.withdraw = this.selectAll ? balance - balance % 100 : null
        },
        isShowSelectStatus(status) {
            return this.type === 'admin' && !['cancelled', 'success'].includes(status) &&
                this.permissions &&
                this.permissions.includes('edit-withdraws')
        },
        closePayoutDialog() {
            this.payoutDialog = false
        },
        openPayoutDialog() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.payoutDialog = true
            }
        },
        exportToExcel() {
            this.getPayoutsByPage(1, false, true)
        }
    }
}
</script>
